module.exports = __webpack_public_path__ + "small-house.611c60.png";